import styles from './Filter.module.css';

import Icon from '@mui/material/Icon';

import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';

import React from 'react';

export const Filter = ({ filters, onFilterChange, onClearFilters }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const toggleExpanded = () => setIsExpanded(!isExpanded);

    const handleInputChange = (field, value) => {
        onFilterChange({ ...filters, [field]: value });
    };

    const hasActiveFilters = filters.search;

    return (
        <div className={styles.filterContainer}>
            <div className={styles.filterHeader} onClick={toggleExpanded}>
                <span>
                    {hasActiveFilters && <span className={styles.activeIndicator}>●&nbsp;</span>}
                    Filter
                </span>
                <span>
                    <Icon>{ isExpanded ? <ExpandLess /> : <ExpandMore /> }</Icon>
                </span>
            </div>

            <div className={`${styles.filterContent} ${isExpanded ? styles.expanded : styles.collapsed}`}>
                <div className={styles.searchSection}>
                    <input
                        type="text"
                        placeholder="Search by name, email, phone, NSP number, or certification"
                        value={filters.search}
                        onChange={(e) => handleInputChange('search', e.target.value)}
                        className={styles.searchInput}
                    />
                </div>

                {hasActiveFilters && (
                    <button 
                        className={styles.clearButton} 
                        onClick={onClearFilters}
                    >
                        Clear Filters
                    </button>
                )}
            </div>
        </div>
    );
};